import {NgModule} from '@angular/core';
import { LandingPageComponent } from './landing-page.component';
import { LandingPageRoutingModule } from './landing-page-routing.module';
import { SwiperModule } from 'angular2-useful-swiper';
import {CommonModule} from '@angular/common';
//import {CategoriesListRoutingModule} from './category-list-routing.module';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [CommonModule,SwiperModule, LandingPageRoutingModule],
  exports: [LandingPageComponent],
})
export class LandingPageModule {
}



// WEBPACK FOOTER //
// ./src/app/landing-page/landing-page.module.ts